import { TOPUP_MANAGEMENT } from "api/ApiPath";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { isEmpty, isUndefined } from "lodash";
import { injectable } from "tsyringe";
import { MobileDataService } from "utils/enums/MobileDataEnums";
import { CategoryAddtionRequestModel } from "./model/categoryAddtion/CategoryAddtionRequestModel";
import { CategoryAddtionResponseModel } from "./model/categoryAddtion/CategoryAddtionResponseModel";
import { TopupCreateRequestModel } from "./model/create/TopupCreateRequestModel";
import { TopupDeleteResponseModel } from "./model/delete/TopupDeleteResponseModel";
import { TopupPackageDetailModel } from "./model/detail/TopupDetailReponseModel";
import { SupplierAddtionResponseModel } from "./model/supplierAddition/SupllierAddtionResponseModel";
import { SupplierAddtionRequestModel } from "./model/supplierAddition/SupplierAddtionRequestModel";
import { TopupRequestModel } from "./model/TopupRequestModel";
import { TopupResponseModel } from "./model/TopupResponseModel";
import { TopupUpdateRequestModel } from "./model/update/TopupUpdateRequestModel";

export interface ITopupManagementRepository {
  getList(
    params: TopupRequestModel,
  ): Promise<ListBaseApiResponseModel<TopupResponseModel>>;
  detailTopup(
    code: string,
  ): Promise<BaseApiResponseModel<TopupPackageDetailModel>>;
  updateTopup(
    body: TopupUpdateRequestModel,
  ): Promise<BaseApiResponseModel<TopupResponseModel>>;
  createTopup(
    body: TopupCreateRequestModel,
  ): Promise<BaseApiResponseModel<TopupResponseModel>>;
  deleteTopup(
    body: [{ code: string }],
  ): Promise<BaseApiResponseModel<TopupDeleteResponseModel>>;
  addSupplier(
    body: SupplierAddtionRequestModel,
  ): Promise<BaseApiResponseModel<Array<SupplierAddtionResponseModel>>>;
  addCategory(
    body: CategoryAddtionRequestModel,
  ): Promise<BaseApiResponseModel<Array<CategoryAddtionResponseModel>>>;
}

@injectable()
export class TopupManagementImpl implements ITopupManagementRepository {
  async getList(
    params: TopupRequestModel,
  ): Promise<ListBaseApiResponseModel<TopupResponseModel>> {
    let categoryGroup = [];
    let isNotBuyPackage = params?.service !== MobileDataService.BuyPackage;
    !isEmpty(params.categoriesForQuery) &&
      categoryGroup?.push(params?.categoriesForQuery);
    !isUndefined(params?.category) &&
      params?.category !== params?.categoriesForQuery &&
      categoryGroup?.push(params?.category);
    let queryString = categoryGroup?.map((item, index) => {
      return `${
        index !== categoryGroup?.length - 1 || categoryGroup?.length === 1
          ? "?"
          : "&"
      }categories[${index}]=${item}`;
    });
    delete params.categoriesForQuery;
    isNotBuyPackage && delete params?.category;
    return await client?.get(
      `${TOPUP_MANAGEMENT?.LIST}${
        !isEmpty(queryString) && !isUndefined(queryString) && isNotBuyPackage
          ? queryString.join("")
          : ""
      }`,
      params,
    );
  }

  async detailTopup(
    id: string,
  ): Promise<BaseApiResponseModel<TopupPackageDetailModel>> {
    return await client?.get(`${TOPUP_MANAGEMENT?.DETAIL}`, { id: id });
  }

  async updateTopup(
    body: TopupUpdateRequestModel,
  ): Promise<BaseApiResponseModel<TopupResponseModel>> {
    let id = body?.id;
    delete body?.id;
    return await client?.put(
      `${TOPUP_MANAGEMENT?.UPDATEV2}/${id}/update`,
      body,
    );
  }

  async createTopup(
    body: TopupCreateRequestModel,
  ): Promise<BaseApiResponseModel<TopupResponseModel>> {
    return await client?.post(TOPUP_MANAGEMENT?.CREATEV2, body);
  }

  async deleteTopup(
    body: [{ code: string }],
  ): Promise<BaseApiResponseModel<TopupDeleteResponseModel>> {
    return await client?.delete(TOPUP_MANAGEMENT?.DELETE, {
      data: { code: body?.[0]?.code },
    });
  }

  async addSupplier(
    body: SupplierAddtionRequestModel,
  ): Promise<BaseApiResponseModel<Array<SupplierAddtionResponseModel>>> {
    return await client?.post(TOPUP_MANAGEMENT?.ADD_SUPPLIER, body);
  }

  async addCategory(
    body: CategoryAddtionRequestModel,
  ): Promise<BaseApiResponseModel<Array<CategoryAddtionResponseModel>>> {
    return await client?.post(TOPUP_MANAGEMENT?.ADD_CATEGORY, body);
  }
}
